module.exports = __webpack_public_path__ + "img/hangyedefen.89390c5e.png";